import request from '@/utils/request'

// 获取系统更新日志
export function GetVersionLog () {
  return request({
    url: 'post/system/GetVersionLog'
  })
}

export function SaveCommon (params) {
  return request({
    url: 'post/system/SaveCommon',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/system.js